module.exports = window["braintree"]["fastlane"];